import { loginApi } from '../api';

type LoginResponse = string;

interface LoginRequest {
  email: string;
  password: string;
  token?: string;
  trusted?: boolean;
}

interface RateLimitingData {
  attempts: {
    allowed: number;
    left: number;
    window: {
      unit: string;
      value: number;
    };
  };
}

export interface LoginInvalidCredentialsErrorResponse {
  meta: RateLimitingData;
}

export interface LoginTooManyAttemptsErrorResponse {
  meta: RateLimitingData;
}

const login = async (loginRequest: LoginRequest) => {
  if (!__CONFIG__.waf.challenge_enabled) {
    return loginApi.post<LoginResponse>('/users.login', loginRequest);
  }

  const response = await window.AwsWafIntegration.getToken()
    .then((token) => {
      const headers = { 'x-aws-waf-token': token };

      return loginApi.post<LoginResponse>('/users.login', loginRequest, headers);
    });

  return response;
};

export default login;
